import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const WHATSAPP_NUMBER = "905072200492";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent("Merhaba, FINORA lansmana özel fiyat teklifi hakkında bilgi almak istiyorum.")}`;

export default function LaunchPopup() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const dismissed = sessionStorage.getItem("finora-popup-dismissed");
    if (!dismissed) {
      const timer = setTimeout(() => setOpen(true), 2500);
      return () => clearTimeout(timer);
    }
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("finora-popup-dismissed", "true");
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-4"
          data-testid="launch-popup-overlay"
        >
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={close} />

          {/* Popup */}
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.92, y: 20 }}
            transition={{ duration: 0.4, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="relative w-full max-w-[480px] overflow-hidden shadow-2xl"
            data-testid="launch-popup"
          >
            {/* Full image as WhatsApp link */}
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="popup-whatsapp-btn"
              className="block"
            >
              <img
                src="/images/popup-hero.jpg"
                alt="FINORA Lansman - WhatsApp ile iletişime geçin"
                className="w-full block"
              />
            </a>

            {/* Close */}
            <button
              onClick={close}
              data-testid="popup-close-btn"
              className="absolute top-3 right-3 z-20 w-8 h-8 flex items-center justify-center text-white/80 hover:text-white bg-black/30 hover:bg-black/50 rounded-full transition-all duration-200"
            >
              <X className="w-4 h-4" strokeWidth={2} />
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
